module.exports = __webpack_public_path__ + "static/05-59b8a5d8a89927404694b77858f0eebe.jpg";